import { PeriodPickerProps } from '@touche-lts/panel-ui/dist'
import { NamedImageDTO, UserDTO } from 'models';

export interface UsersTableSearchProps {
  name: string
  roleId: number
  email: string
  storeName: string
  addedOnPeriod: PeriodPickerProps['period']
}

export enum UsersTableSortProps {
  NAME = 'name',
  ROLE = 'roles',
  EMAIL = 'emailAddress',
  STORE = 'storeName',
  ADDED_ON = 'created'
}

export interface UsersTableEntry {
  id: UserDTO['id']
  imageUrl: UserDTO['imageUrl']
  fullName: string // UserDTO['firstName'] + UserDTO['lastName']
  role: UserDTO['role']
  emailAddress: UserDTO['emailAddress']
  stores: NamedImageDTO[]
  addedOn: UserDTO['created']
}
